module.exports = __webpack_public_path__ + "static/alto-logo-7a6603ed13fa6383d3ca03f5f6c717b5.png";